module.exports = __webpack_public_path__ + "img/logo-french-mobility-120.4b3f129f.png";